import { Lock } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconLock(props: Readonly<IconWrapperProps>) {
  return (
    <IconWrapper {...props}>
      <Lock />
    </IconWrapper>
  );
}
